angular.module('bbl.module.profile.routing', [])
  .config(['$routeProvider', profileRoutingSetup]);

function profileRoutingSetup($routeProvider) {
  var resolveAuth = {
    profile: ["Auth", function(Auth) {
      return Auth.getProfile().then(function(response) {
        return response.data.profile;
      });
    }], permissions: ["Auth", function(Auth) {
      return Auth.getPermission().then(function(response) {
        return response.data.permission_level;
      });
    }]
  };
  
  var profileRoute = {
    templateUrl: 'profile-template.html',
    controller: 'ProfileController',
    resolve: resolveAuth
  };

  $routeProvider.when('/profile', profileRoute);
}


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/profile/profile.routing.js
 ** module id = 358
 ** module chunks = 0
 **/